import { loadAsync } from './loadAsync';

let wistiaLoaded = false;
let wistiaLoadPromise: Promise<HTMLScriptElement> | null = null;

export function loadWistiaVideo(_videoId: string) {
  const promises: Promise<HTMLScriptElement>[] = [];

  if (!wistiaLoaded) {
    wistiaLoaded = true;
    const clearPromise = function () {
      wistiaLoadPromise = null;
    };
    wistiaLoadPromise = loadAsync('//fast.wistia.com/assets/external/E-v1.js').finally(
      clearPromise,
    );
    promises.push(wistiaLoadPromise);
  } else if (wistiaLoadPromise) {
    promises.push(wistiaLoadPromise);
  }

  return Promise.all(promises);
}
